import React from "react";
import "../../styles/WorkingProcess.css";
import {
  FaLightbulb,
  FaUsers,
  FaCode,
  FaCogs,
  FaAward,
  FaPaperPlane,
} from "react-icons/fa";

const WorkProcess = () => {
  const steps = [
    {
      id: 1,
      title: "Discovery & Understanding",
      color: "green",
      
      icon: <FaLightbulb />,
      desc: "We understand your business, goals, target audience, and requirements in detail to build the right strategy."
    },
    {
      id: 2,
      title: "Strategy & Planning",
      color: "#0868a0",
      icon: <FaUsers />,
      desc: "We create a clear roadmap for your website, design, development, and AI automation system to ensure everything is goal-oriented."
    },
    {
      id: 3,
      title: "UI/UX Design",
      color: "green",
      icon: <FaCode />,
      desc: "We design modern, user-friendly, and conversion-focused layouts that provide the best experience for your visitors."
    },
    {
      id: 4,
      title: "Development & Integration",
      color: "#0868a0",
      icon: <FaCogs />,
      desc: "We develop your website and integrate advanced features, tools, and AI automation systems for smooth functionality."
    },
    {
      id: 5,
      title: "Testing & Optimization",
      color: "green",
      icon: <FaAward />,
      desc: "We thoroughly test performance, speed, responsiveness, and automation flows to ensure everything works perfectly."
    },
    {
      id: 6,
      title: "Launch & Continuous Growth",
      color: "#0868a0",
      icon: <FaPaperPlane />,
      desc: "We launch your project and provide ongoing support, updates, and optimization to keep improving results."
    }
  ];

  return (
    <section className="work-process-section">
      <h2 className="work-title">Our Proven Work Process</h2>
      <p className="work-subtitle">
       We follow a simple, structured 6-step process to turn your idea into a fully working, growth-focused digital system.
      </p>

      <div className="process-wrapper">
        {/* STEP LABELS */}
        <div className="process-line">
          {steps.map((step) => (
            <div
              key={step.id}
              className="process-step"
              style={{ backgroundColor: step.color }}
            >
              {step.title}
            </div>
          ))}
        </div>

        {/* STEP DETAILS */}
        <div className="process-grid">
          {steps.map((step) => (
            <div className="process-item" key={step.id}>
              <div
                className="process-iconv"
                style={{ borderColor: step.color, color: step.color }}
              >
                {step.icon}
              </div>
              <h3 className="process-num" style={{ color: step.color }}>
                {step.id.toString().padStart(2, "0")}
              </h3>
              <p className="process-text">{step.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WorkProcess;
